import type { FC, PropsWithChildren } from 'react';
import { createContext } from 'react';

import type { CartState } from './types';
import { initialCartState, useCart } from './useCart';

export const CartContext = createContext<CartState>(initialCartState);

export const CartProvider: FC<PropsWithChildren> = ({ children }) => {
  const cart = useCart();

  return <CartContext.Provider value={cart}>{children}</CartContext.Provider>;
};

CartProvider.displayName = 'CartProvider';
